'use strict';
var defineWellKnownSymbol = require('../internals/well-known-symbol-define');

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.match.js
// module id = 611
// module chunks = 0